export const LuckyBoxItemId = {
  AMOUNT_50: 1,
  AMOUNT_100: 2,
  AMOUNT_500: 3,
  AMOUNT_1000: 4
} as const

export const QuizItemId = {
  AMOUNT_50: 5,
  AMOUNT_100: 6,
  AMOUNT_500: 7,
  AMOUNT_1000: 8
} as const
